module.exports = __webpack_public_path__ + "static/media/retirement-object-3-1-2.9e21856d.svg";